import { MailOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { FloatInput, Tag, Text } from 'UI';

export const SInput = styled(FloatInput)`
  height: 40px;
  width: 350px;
`;

export const SMailOutlined = styled(MailOutlined)`
  margin-right: '5px';
`;

export const STag = styled(Tag)`
  background-color: ${({ theme }) => theme.color.grey95};
  border-radius: 16px;
`;

export const SText = styled(Text)`
  padding-left: 10px;
  padding-top: 5px;
`;
